import React, { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import AppLandingPage from "../../All_Projects_Landing_Pages/AppLandingPage";
import Report from "../../common/Report";
import { FieldsProvider } from "../../../context/FieldsContext";
import HypertensionPdfDetails from "../../../components/pdfReports/HypertensionPdfReport";
import {
  getImagesFromDB,
  fetchAndStoreImages,
} from "../../../utils/imageUtils";
import HypertensionComponent from "../../All_Project_Components/HypertensionComponent";

const HypertensionRoutes = (props) => {
  const HYPERTENSION_LANDING_URL =
    "https://clinical-server-apis.azurewebsites.net/fields/hypertension";
  const HYPERTENSION_REPORT_URL =
    "https://clinical-server-apis.azurewebsites.net/hypertension";

  const [formDetails, setFormDetails] = useState({});
  const [PdfInfo, setPDFDetails] = useState({});
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState([]);
  const [units, setUnits] = useState({});

  const app = "hypertension";

  const color = "#3f6f7aff";
  const secondaryColor = "#54A1B2";
  const button_hover_color = "#a0c4cbff";
  const surface_color = "#dfeaedff";
  const surface_hover_color = "#a9c3c9ff";
  const surface_highlight_color = "#dcdaf5";
  const gender_highlight_color = "#675496";
  const button_color = "rgb(123, 104, 171)";
  const surface_highlight_dark_color = "rgb(103, 84, 150)";

  const form_details = (props) => {
    const parseNum = (val) => {
      if (val === undefined || val === null || val === "" || isNaN(val)) return 0;
      const num = parseFloat(val);
      return isNaN(num) ? 0 : num;
    };

    const details = {
      id: props.patient_id || props.id || props.UHID,
      patient_id: props.patient_id || props.id || props.UHID,
      name: props.name || "",
      age: parseNum(props.age),
      gender: props.gender || "",
      location: props.location || "",
      email: props.email || "",
      phone: props.phone || "",
      height: parseNum(props.height),
      weight: parseNum(props.weight),
      bmi: parseNum(props.BMI || props.bmi),

      heart_rate: parseNum(props.heart_rate),
      heart_symptoms: props.heart_symptoms || props.heart_related_symptoms || "No",
      heart_related_symptoms: props.heart_symptoms || props.heart_related_symptoms || "No",
      heart_disease: props.heart_disease || props.prev_heart_disease || "No",
      prev_heart_disease: props.heart_disease || props.prev_heart_disease || "No",

      diet: props.diet || "Mixed Diet",
      alcohol: props.alcohol || "No",
      smoking: props.smoking || props.smoke || "No",
      smoke: props.smoke || props.smoking || "No",
      tobacco: props.tobacco || "No",
      physical_activity: props.physical_activity || "Sedentary",

      familyHistory: props.familyHistory || props.family_history_of_diabetes || "No",
      family_history_of_diabetes: props.familyHistory || props.family_history_of_diabetes || "No",
      family_history_list: props.family_history_list || [],
      family_heart_disease: props.family_heart_disease || props.family_history_heart_disease || "No",
      family_history_heart_disease: props.family_heart_disease || props.family_history_heart_disease || "No",

      diabetes: props.diabetes || "No Diabetes",
      diabetes_final: props.diabetes || "No",
      dyslipidemia: props.dyslipidemia || props.dyslipidaemia || "No",
      dyslipidaemia: props.dyslipidemia || props.dyslipidaemia || "No",
      dyslipidemia_list: props.dyslipidemia_list || [],
      osa: props.osa || props.osa_keyword || "No",
      osa_keyword: props.osa || props.osa_keyword || "No",

      total_wbc: parseNum(props.total_wbc),
      neutrophil_count: parseNum(props.neutrophil_count || props.neutrophils),
      lymphocyte_count: parseNum(props.lymphocyte_count),
      triglycerides: parseNum(props.triglycerides),
      total_cholesterol: parseNum(props.total_cholesterol),
      hdl: parseNum(props.hdl),
      ldl: parseNum(props.ldl),
    };
    const pdf_details = {
      basic_info: {
        UHID: props.patient_id || props.id || props.UHID || "",
        Name: props.name || "",
        Age: props.age || "",
        Gender: props.gender || "",
        Location: props.location || "",
        Mobile: props.phone || "",
      },
      "Vital Signs": {
        Height: props.height,
        Weight: props.weight,
        BMI: props.BMI || props.bmi,
        "Heart Rate": props.heart_rate,
      },

      "Life Style": {
        Diet: props.diet,
        Alcohol: props.alcohol,
        Smoking: props.smoking || props.smoke,
        Tobacco: props.tobacco,
        "Physical Activity": props.physical_activity,
      },

      "Family History": {
        "Family History of Diabetes": props.familyHistory || props.family_history_of_diabetes,
        "Family History of Heart Disease": props.family_heart_disease || props.family_history_heart_disease,
      },

      "Medical History": {
        "Diabetes Mellitus": props.diabetes,
        "Chest Pain / Shortness of Breath": props.heart_symptoms || props.heart_related_symptoms,
        "History Of Heart Disease": props.heart_disease || props.prev_heart_disease,
        Dyslipidemia: props.dyslipidemia || props.dyslipidaemia,
        "Obstructive Sleep Apnea": props.osa || props.osa_keyword,
      },
      "Lab History": {
        "Total WBC": props.total_wbc,
        "Neutrophil Count": props.neutrophil_count || props.neutrophils,
        "Lymphocyte Count": props.lymphocyte_count,
        Triglycerides: props.triglycerides,
        "Total Cholesterol": props.total_cholesterol,
        HDL: props.hdl,
        LDL: props.ldl,
      },
    };

    const units = {
      Height: "cm",
      Weight: "kg",
      BMI: "kg/m2",
      "Heart Rate": "/min",
      "Total WBC": "cells/mcL",
      "Neutrophil Count": "%",
      "Lymphocyte Count": "%",
      Triglycerides: "mg/dL",
      "Total Cholesterol": "mg/dL",
      HDL: "mg/dL",
      LDL: "mg/dL",
    };
    setUnits(units);
    setFormDetails(details);
    setPDFDetails(pdf_details);
  };

  useEffect(() => {
    const loadImages = async () => {
      try {
        const storedImages = await getImagesFromDB(app);
        if (storedImages.length > 0) {
          setImages(storedImages);
        } else {
          const urls = [
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/apollo-logo.png",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/iStock-644984072_vhiiap_c_scale%252Cw_1400.jpg",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/aicvd-app-page-1.jpg",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/aicvd-app-page-2.jpg",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/intepretation-img-1.jpg",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/apollo_certificate_MD%20763515.png",
          ];
          await fetchAndStoreImages(app, urls, setImages);
        }
      } catch (error) {
        console.error("Error fetching images:", error);
      } finally {
        setLoading(false);
      }
    };
    loadImages();
  }, []);

  return (
    <FieldsProvider>
      <Routes>
        <Route
          path="/"
          element={
            <AppLandingPage
              LANDING_URL={HYPERTENSION_LANDING_URL}
              app={app}
              surface_color={surface_color}
              surface_highlight_color={surface_highlight_color}
              surface_hover_color={surface_hover_color}
              color={color}
              button_hover_color={button_hover_color}
              secondaryColor={secondaryColor}
              images={images}
              loading={loading}
            />
          }
        />
        <Route
          path="patient-details"
          element={
            <HypertensionComponent
              app={app}
              surface_color={surface_color}
              surface_highlight_color={surface_highlight_color}
              surface_hover_color={surface_hover_color}
              color={color}
              button_hover_color={button_hover_color}
              secondaryColor={secondaryColor}
              gender_highlight_color={gender_highlight_color}
              surface_highlight_dark_color={surface_highlight_dark_color}
              button_color={button_color}
              form_details={form_details}
            />
          }
        />
        <Route
          path="report"
          element={
            <Report
              app={app}
              formDetails={formDetails}
              REPORT_URL={HYPERTENSION_REPORT_URL}
              surface_color={surface_color}
              surface_highlight_color={surface_highlight_color}
              surface_hover_color={surface_hover_color}
              color={color}
              button_hover_color={button_hover_color}
              secondaryColor={secondaryColor}
            />
          }
        />
        <Route
          app={app}
          path="pdfreport"
          element={
            <HypertensionPdfDetails
              formDetails={formDetails}
              PdfInfo={PdfInfo}
              color={color}
              units={units}
            />
          }
        />
      </Routes>
    </FieldsProvider>
  );
};

export default HypertensionRoutes;
